import {
  ExclamationCircleIcon,
  InformationCircleIcon
} from '@heroicons/react/20/solid'
import { FC, useMemo } from 'react'

import { REQUIRED_FIELD_MESSAGE } from '@/app/constants/validation'

import AppInputMessage from './AppInputMessage'

type Props = {
  valueLength?: number
  minLength?: number
  maxLength?: number
  isLengthInvalid?: boolean
  showMessageValid?: boolean
  textColor?: string
  dataTestId?: string
}

const MinMaxLengthMessage: FC<Props> = ({
  valueLength,
  minLength,
  maxLength,
  isLengthInvalid,
  textColor,
  showMessageValid = true,
  dataTestId
}) => {
  const lengthTextColor = isLengthInvalid
    ? 'text-red-80'
    : textColor ?? 'text-black/50'

  const LengthIcon = isLengthInvalid
    ? ExclamationCircleIcon
    : InformationCircleIcon
  const lengthIconColor = isLengthInvalid
    ? 'text-red-60'
    : textColor ?? 'text-black/50'

  const message = useMemo(() => {
    if (minLength) {
      return valueLength || !isLengthInvalid
        ? `Не менее ${minLength} символов`
        : REQUIRED_FIELD_MESSAGE
    }
    if (maxLength) {
      return `${valueLength} из ${maxLength} символов`
    }
  }, [isLengthInvalid, maxLength, minLength, valueLength])

  if (!isLengthInvalid && !showMessageValid) {
    return null
  }

  return (
    <AppInputMessage
      dataTestId={dataTestId}
      Icon={LengthIcon}
      message={message}
      iconClassName={lengthIconColor}
      messageClassName={lengthTextColor}
    />
  )
}

export default MinMaxLengthMessage
